<template>
  <v-navigation-drawer
    v-if="navItems.length"
    v-model="drawer"
    :order="drawerOrder"
    :permanent="desktopMode"
    width="300"
  >
    <v-toolbar
      v-if="mobileMode"
      class="app-toolbar"
      color="white"
    >
      <IconButton
        v-if="mobileMode"
        class="toolbar-back-btn"
        icon="mdi:close"
        icon-size="24"
        size="36"
        @click="drawer = false"
      />

      <v-toolbar-title class="toolbar-app-title pr-2">
        <SiteTitle class="ml-1" />
      </v-toolbar-title>
    </v-toolbar>

    <NavList>
      <template
        v-for="item in navItems"
        :key="item.path"
      >
        <v-list-group
          v-if="item.type === 'group'"
          :value="item.text"
        >
          <template #activator="{ props }">
            <v-list-item
              v-bind="props"
            >
              <template #title>
                <h4 class="text-h4">
                  {{ item.text }}
                </h4>
              </template>
            </v-list-item>
          </template>

          <v-list-item
            v-for="subitem in item.nav_items"
            :key="subitem.path"
            :disabled="!subitem.path"
            :title="subitem.text"
            :to="subitem.path"
          />
        </v-list-group>

        <v-list-item
          v-else
          :disabled="!item.path"
          :title="item.text"
          :to="item.path"
        />
      </template>
    </NavList>
  </v-navigation-drawer>

  <v-app-bar
    class="site-bar"
    :class="{ 'pl-2': !(navItems.length && mobileMode) }"
    elevation="0"
    :order="navOrder"
  >
    <IconButton
      v-if="navItems.length && mobileMode"
      icon="mdi:menu"
      icon-size="24"
      size="36"
      variant="text"
      @click.stop="drawer = !drawer"
    />

    <SiteBarLink />

    <NavAppsMenu />

    <!-- <NavNotificationsMenu /> -->

    <NavAccountMenu />

    <NuxtLoadingIndicator
      class="nav-loading-indicator"
      color="white"
    />
  </v-app-bar>
</template>

<script setup lang="ts">
const { mobileMode, desktopMode } = useDisplayMode();
const drawer = ref<boolean | null>(null);
const config = useAppConfig();
const { current: currentApp } = storeToRefs(useApps());
const navItems = computed(() => currentApp.value?.nav_items || []);

// Place the navbar and nav drawer at the same order, just with their places swapped on mobile vs desktop
const order = config.layoutOrders.navAndSidebar;
const navOrder = computed(() => order + (desktopMode.value ? 0 : 1));
const drawerOrder = computed(() => order + (desktopMode.value ? 1 : 0));
</script>

<style scoped lang="scss">
@import "~/assets/styles/variables";

.app-toolbar {
  padding-bottom: 2px; // match height of main nav
  border-bottom: 1px solid $faint-line;
}

.nav-loading-indicator {
  position: absolute;
  top: auto;
  bottom: 0;
}

.v-toolbar-title.toolbar-app-title {
  line-height: 1rem;

  .toolbar-back-btn + & {
    margin-inline-start: 4px;
  }
}
</style>
